// mockApi.ts
import { useQuery } from "@tanstack/react-query"
// import type { Program, Specialization } from "../types/form-types"
// import { logger } from "../utils/logger"
import { api } from "@/lib/api"
import type { FormType } from "@/types/form-types"

// // Mock dataset
// const programs: Program[] = [
// 	{ id: "p1", name: "Computer Science" },
// 	{ id: "p2", name: "Electrical Engineering" },
// 	{ id: "p3", name: "Mechanical Engineering" },
// ]

// const specializations: Specialization[] = [
// 	{ id: "e1", name: "Machine Learning", programId: "p1" },
// 	{ id: "e2", name: "Data Mining", programId: "p1" },
// 	{ id: "e3", name: "Embedded Systems", programId: "p2" },
// 	{ id: "e4", name: "VLSI Design", programId: "p2" },
// 	{ id: "e5", name: "Thermodynamics", programId: "p3" },
// 	{ id: "e6", name: "Fluid Mechanics", programId: "p3" },
// ]
export default function useCourses() {
	const useGetProgramTypes = ({
		universityId,
		batchId,
		applicationId,
		type,
		widgetId,
	}: {
		universityId: string
		batchId: string
		applicationId: string
		type: FormType
		widgetId: string
	}) => {
		const isWidget = type === "WIDGET"
		return useQuery({
			queryKey: isWidget
				? ["get-program-types", universityId, widgetId]
				: ["get-program-types", universityId, batchId, applicationId],
			enabled: isWidget
				? Boolean(universityId && widgetId)
				: Boolean(universityId && batchId && applicationId),
			queryFn: async () => {
				if (isWidget) {
					const { data } = await api.get<
						Array<{ label: string; value: string }>
					>(
						`/universities/${universityId}/widgets/${widgetId}/programs-types`,
					)
					return data
				}

				const { data } = await api.get<
					Array<{ label: string; value: string }>
				>(
					`/universities/${universityId}/batches/${batchId}/applications/${applicationId}/programs-types`,
				)
				return data
			},
		})
	}

	const useGetPrograms = ({
		universityId,
		batchId,
		applicationId,
		programTypeId,
		type,
		widgetId,
	}: {
		universityId: string
		batchId: string
		applicationId: string
		programTypeId: string
		type: FormType
		widgetId: string
	}) => {
		const isWidget = type === "WIDGET" || type === "DEFAULT_WIDGET"

		return useQuery({
			queryKey: isWidget
				? ["get-programs", universityId, widgetId, programTypeId]
				: [
						"get-programs",
						universityId,
						batchId,
						applicationId,
						programTypeId,
					],
			enabled: isWidget
				? Boolean(universityId && widgetId && programTypeId)
				: Boolean(
						universityId &&
							batchId &&
							applicationId &&
							programTypeId,
					),
			queryFn: async () => {
				if (isWidget) {
					const { data } = await api.get<
						Array<{ label: string; value: string }>
					>(
						`/universities/${universityId}/widgets/${widgetId}/${programTypeId}/programs`,
					)
					return data
				}

				const { data } = await api.get<
					Array<{ label: string; value: string }>
				>(
					`/universities/${universityId}/batches/${batchId}/applications/${applicationId}/${programTypeId}/programs`,
				)
				return data
			},
		})
	}

	const useGetSpecializations = ({
		universityId,
		batchId,
		applicationId,
		programId,
		type,
		widgetId,
	}: {
		universityId: string
		batchId: string
		applicationId: string
		programId: string
		type: FormType
		widgetId: string
	}) => {
		const isWidget = type === "WIDGET" || type === "DEFAULT_WIDGET"

		return useQuery({
			queryKey: isWidget
				? ["get-specializations", universityId, widgetId, programId]
				: [
						"get-specializations",
						universityId,
						batchId,
						applicationId,
						programId,
					],
			enabled: isWidget
				? Boolean(universityId && widgetId && programId)
				: Boolean(
						universityId && batchId && applicationId && programId,
					),
			queryFn: async () => {
				if (isWidget) {
					const { data } = await api.get<
						Array<{ label: string; value: string }>
					>(
						`/universities/${universityId}/widgets/${widgetId}/${programId}/specializations`,
					)
					return data
				}

				const { data } = await api.get<
					Array<{ label: string; value: string }>
				>(
					`/universities/${universityId}/batches/${batchId}/applications/${applicationId}/${programId}/specializations`,
				)
				return data
			},
		})
	}
	return {
		useGetPrograms,
		useGetSpecializations,
		useGetProgramTypes,
	}
}
